import { DSBDataLocalStorage } from './DSBDataLocalStorage';
import { mapFromQuery } from './queryObjectMapper';
export class DSBDataQueryStringStorage extends DSBDataLocalStorage {
  getItem(name) {
    const formData = this.storage.getItem(name);
    return JSON.stringify(mapFromQuery(formData));
  }

}